import Api from '../api';

const resource = '/translate';

interface KeysList {
  [key: number]: string;
}

export default {
  get(code: string, list: KeysList) {
    return Api.post(`${resource}`, {
      code,
      list,
    });
  },
};
